import React, { useEffect, useState } from "react";
import { InputText } from 'primereact/inputtext';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAsterisk } from "@fortawesome/free-solid-svg-icons";
import { ToWords } from 'to-words';

const toWords = new ToWords({
  localeCode: 'en-IN', // Indian numbering format
  converterOptions: {
    currency: false,
    ignoreDecimal: true,
  }
});

const DoInputField = (props) => {
    const id = props.id ? props.id : props.name;
    const label = props.label ? props.label : '';
    const name = props.name;
    const type = props.type ? props.type : 'text';
    let field = props.field;
    const placeholder = props.placeholder;
    const style = props.style ? props.style : null;
    const limit = 1e9; // 100 crore limit
    let item = props.item || null;

  const [isDisabled, setIsDisabled] = useState(false);

  useEffect(() => {
    
    if (
      item?.disableOnHasValue &&
      props.rowData?.[item?.name] &&
      (props.screenName === "Agents" ||
        (props.screenName === "Clients" && props.rowData?.isPasswordChanged))
    ) {
      setIsDisabled(true);
    }

  }, [props.rowData]);

    let markRequired = () => {
        return (
          <FontAwesomeIcon
            color='red'
            icon={faAsterisk}
            style={{ width: '7px',marginBottom:"5px",marginLeft:"2px" }}
          />
        );
      };

  const onChange = (e) => {
    let value = e.target.value;
    const parsedValue = parseFloat(value);

    const isValidValue =
      item?.valuePattern?.test(value) ||
      !value ||
      (!isNaN(parsedValue) && parsedValue <= limit && props.displayPrice && !item?.valuePattern) ||
      (!props.displayPrice && !item?.valuePattern) ||
      value === '';

    if (isValidValue) {
      let processedValue = typeof value === 'string' ? value.trimStart() : value;

      if (item?.capitalizeValue && typeof processedValue === 'string') {
        processedValue = processedValue.charAt(0).toUpperCase() + processedValue.slice(1);
      }
      field.onChange(processedValue);
    }
    if (props.onChange) {
      props.onChange(e);
    }
  };

  const parsedNumber = field.value ? parseFloat(field.value) : NaN;

    return (
        <div className="flex flex-column">
             <div className="flex align-center"> {/* Added a wrapper div with flex class */}
                <label htmlFor={id} className="text-capitalize">{label}</label>
                {props.markReq && props.markReq === true && markRequired()}
            </div>
            <InputText 
            type={type}
            onKeyDown={(e) => {
              // Check if the type is 'number' before preventing the 'e' key
              if (type === 'number' && (e.key === 'e' || e.key === 'E')) {
                e.preventDefault();
              }
            }} 
            value={field.value}
            id={id} 
            name={name} 
            placeholder={placeholder}
            aria-describedby="username-help" 
            style={style}
            disabled={isDisabled}
            maxLength={item?.maxLength}
            onChange={onChange} /> 
        <small className="text-danger mt-1">{props.fieldState.invalid ? props.errors[props.name]?.message : ''}</small>
        <span>
          {props.displayPrice && !isNaN(parsedNumber) && parsedNumber <= limit && parsedNumber > 0 && (
            <span className="number_to_words">
              {toWords.convert(parsedNumber)} {/* Convert number to words in Indian format */}
            </span>
          )}
        </span>    
        </div>
    )
}

export default DoInputField;